import { GridCellProps } from '@progress/kendo-react-grid';

type AnalysisStatusCellProps = {
  ok: boolean;
  decimals: number;
} & GridCellProps;

export const AnalysisStatusCell = ({
  dataItem,
  field,
  decimals,
  ok
}: AnalysisStatusCellProps) => {
  const color =
    dataItem.measuredValue !== null && dataItem.measuredValue !== undefined
      ? ok
        ? 'var(--green-status-color)'
        : 'var(--red-status-color)'
      : 'inherit';
  return (
    <td style={{ color: color, textAlign: 'right' }}>
      {dataItem[field!] ? dataItem[field!].toFixed(decimals ?? 3) : null}
    </td>
  );
};
